"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopupModal = require("./PopupModal"),
    $ = "undefined" != typeof window ? window.jQuery : "undefined" != typeof global ? global.jQuery : null;
var ComponentModal = function (_PopupModal) {
  _inherits(ComponentModal, _PopupModal);

  function ComponentModal() {
    var _this;

    var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck(this, ComponentModal);

    (_this = _possibleConstructorReturn(this, (ComponentModal.__proto__ || Object.getPrototypeOf(ComponentModal)).call(this)), _this), _this.options = o || {};return _this;
  }

  _createClass(ComponentModal, [{
    key: "show",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(o, t) {
        var _this2 = this;

        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var e, s;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e = !0;
                null == (n = _extends({}, this.options, n)).footer && (n.footer = [$('<button type="button" class="btn primary">Dismiss</button>').on("click", function () {
                  return _this2.hide();
                }), $('<button type="button" class="btn primary">Request</button>').on("click", _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.t0 = "function" == typeof t.validate;

                          if (!_context.t0) {
                            _context.next = 5;
                            break;
                          }

                          _context.next = 4;
                          return t.validate();

                        case 4:
                          _context.t0 = _context.sent;

                        case 5:
                          _context.t1 = _context.t0;

                          if (!_context.t1) {
                            _context.next = 8;
                            break;
                          }

                          e = !1, _this2.hide();

                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, _this2);
                })))]);s = _get(ComponentModal.prototype.__proto__ || Object.getPrototypeOf(ComponentModal.prototype), "show", this).call(this, o, t, n);
                _context2.next = 5;
                return s;

              case 5:
                return _context2.abrupt("return", e ? null : t);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function show(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return show;
    }()
  }, {
    key: "setFooter",
    value: function setFooter(o) {
      this.options.footer = [o];
    }
  }, {
    key: "setBody",
    value: function setBody(o) {
      this.body = [o];
    }
  }], [{
    key: "show",
    value: function show(o, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return new ComponentModal(n).show(o, t);
    }
  }]);

  return ComponentModal;
}(PopupModal);

module.exports = ComponentModal;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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